import React, { Component } from "react";
import "./InsuranceManagement.css";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Axios from "axios";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import Select from "react-select";
import axios from "axios";
import { token } from "../../appTokenConfig";
import Spinner from "./../../spinner/index";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default class InsuranceManagement extends Component {
  constructor(props) {
    super(props);
    this.update_logo_img_ref = React.createRef();
    this.state = {
      words: {},
      lang: "",
      activeTab: "nav-insurance-create",
      insuranceLogoImage: "",
      insuranceName: "",
      insuranceEmail: "",
      insuranceWebsite: "",
      insuranceRegNumber: "",
      insuranceAddress: "",
      insuranceNote: "",
      primaryColor: "",
      fieldRequireErrors: [],
      secondaryColor: "",
      headerTextColor: "",
      footerTextColor: "",
      primaryContact: "",
      secondaryContact: "",
      OrderNumber: 0,
      partnerId: localStorage.getItem("partnerId"),
      allInsuranceClient: [],
      loading: false,
      createLoading: false,
      //update fields && update insurance related state
      updateInsuranceModal: false,
      updateFieldError: [],
      updateInsuranceLogoImage: "",
      updateInsuranceName: "",
      updateInsuranceEmail: "",
      updateInsuranceWebsite: "",
      updateInsuranceRegNumber: "",
      updateInsuranceAddress: "",
      updateInsuranceNote: "",
      updatePrimaryColor: "",
      updateSecondaryColor: "",
      updateHeaderTextColor: "",
      updateFooterTextColor: "",
      updatePrimaryContact: "",
      updateSecondaryContact: "",
      updateClientId: "",
      updateSubmitLoading: false,
      updateInsuranceOrderBy: "",
      //---------------------------------------------------
      dragOrder: [],
      orderSubmitLoading: false,
    };
  }

  componentDidMount() {
    this.getLang();
    this.getInsuranceDetails();
    this.getFallbackDetails();
  }

  // function for get profile information
  getFallbackDetails = async () => {
    const { partnerId } = this.state;
    const url = `${configuration.getFallbackDetails}?partner_id=${partnerId}`;
    try {
      const response = await axios.get(url);
      if (response.data) {
        this.setState({
          primaryColor: response.data.primary_color,
          secondaryColor: response.data.secondary_color,
          headerTextColor: response.data.primary_text_color,
          footerTextColor: response.data.secondary_text_color,
        });
      } else {
        Toast.fire({
          type: "error",
          title: this.lang("Something went wrong"),
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  // function for get insurance client list
  getInsuranceDetails = async () => {
    this.setState({ loading: true });
    const { partnerId } = this.state;
    const url = configuration.listInsuranceClient;
    const payload = {
      partnerId: partnerId,
    };
    try {
      const response = await axios.post(url, payload);
      if (response.data.data) {
        let orderByArray = [];
        response.data.data.map((item) => orderByArray.push(item.order_by));
        let largest = 0;
        for (let index = 0; index < orderByArray.length; index++) {
          if (orderByArray[index] > largest) {
            largest = orderByArray[index];
          }
        }
        const updatedStateArray = response.data.data.map((item) => ({
          id: item.id,
          order_by: item.order_by,
        }));
        this.setState({
          allInsuranceClient: response.data.data,
          OrderNumber: largest,
          loading: false,
          // dragOrder: updatedStateArray,
        });
      } else {
        Toast.fire({
          type: "error",
          title: this.lang("Something went wrong"),
        });
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  //function for change tab create insurance to view insurance
  handleTabClick = (tabId) => {
    this.setState({ activeTab: tabId });
  };

  // function for change value of input fields
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  // function for submit new insurance
  handleSubmit = async (event) => {
    event.preventDefault();
    let errors = [];
    const {
      insuranceName,
      insuranceEmail,
      insuranceLogoImage,
      insuranceNote,
      primaryColor,
      secondaryColor,
      headerTextColor,
      footerTextColor,
      primaryContact,
      secondaryContact,
      insuranceWebsite,
      insuranceRegNumber,
      insuranceAddress,
      OrderNumber,
      partnerId,
    } = this.state;

    if (insuranceLogoImage.trim() === "") {
      errors.push("Logo is required.");
    }
    if (insuranceName.trim() === "") {
      errors.push("Name is required.");
    }
    if (insuranceEmail.trim() === "") {
      errors.push("Email is required.");
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(insuranceEmail)
    ) {
      errors.push("Invalid email format");
    }

    if (errors.length > 0) {
      this.setState({ fieldRequireErrors: errors });
    } else {
      this.setState({ createLoading: true });

      this.setState({ fieldRequireErrors: [] });
      const url = configuration.createInsuranceClient;
      const payload = {
        Order_by: OrderNumber + 1,
        partnerId: partnerId,
        Logo: insuranceLogoImage,
        Notes: insuranceNote,
        Email: insuranceEmail,
        Name: insuranceName,
        PrimaryColor: primaryColor,
        SecondaryColor: secondaryColor,
        HeaderTextColor: headerTextColor,
        FooterTextColor: footerTextColor,
        PrimaryContact: primaryContact,
        SecondaryContact: secondaryContact,
        Website: insuranceWebsite,
        RegisterNo: insuranceRegNumber,
        Address: insuranceAddress,
      };

      try {
        const response = await axios.post(url, payload);
        if (
          response.data &&
          response.data.code == 200 &&
          response.data.success
        ) {
          Toast.fire({
            type: "success",
            title: "Insurance has been created successfully!",
          });
          this.setState({ createLoading: false });

          this.logo_img_ref.style.backgroundImage = "";
          this.logo_img_ref.innerHTML = `
          <p
            style={{
              fontSize: 16,
              color: "#454545",
              fontWeight: "bold",
              margin: 0,
              padding: "0 10px",
            }}
          >
            ${this.lang("Insurance Logo")}
          </p>
          `;
          this.setState(
            {
              activeTab: "nav-view-insurance",
              insuranceName: "",
              insuranceEmail: "",
              insuranceLogoImage: "",
              insuranceNote: "",
              primaryColor: "",
              secondaryColor: "",
              headerTextColor: "",
              footerTextColor: "",
              primaryContact: "",
              secondaryContact: "",
              insuranceWebsite: "",
              insuranceRegNumber: "",
              insuranceAddress: "",
            },
            () => {
              this.getInsuranceDetails();
              this.getFallbackDetails();
            }
          );
        } else {
          Toast.fire({
            type: "error",
            title: this.lang("Something went wrong"),
          });
          this.setState({ createLoading: false });
        }
      } catch (error) {
        console.error(error);
        this.setState({ createLoading: false });
      }
    }
  };

  onUpdateLogoImageSelect = (event) => {
    if (event.target.files.length) {
      let src = URL.createObjectURL(event.target.files[0]);
      this.update_logo_img_ref.style.backgroundImage = `url(${src})`;
      this.update_logo_img_ref.style.backgroundSize = `contain`;
      this.update_logo_img_ref.style.backgroundRepeat = `no-repeat`;
      this.update_logo_img_ref.style.backgroundPosition = `center`;
      this.update_logo_img_ref.innerHTML = "";

      // To convert local image into base64
      File.prototype.convertToBase64 = function (callback) {
        var reader = new FileReader();
        reader.onloadend = function (e) {
          callback(e.target.result, e.target.error);
        };
        reader.readAsDataURL(this);
      };
      var selectedFile = event.target.files[0];
      selectedFile.convertToBase64((base64) => {
        this.setState({ updateInsuranceLogoImage: base64 });
      });
    }
  };
  onLogoImageSelect = (event) => {
    if (event.target.files.length) {
      let src = URL.createObjectURL(event.target.files[0]);
      this.logo_img_ref.style.backgroundImage = `url(${src})`;
      this.logo_img_ref.style.backgroundSize = `contain`;
      this.logo_img_ref.style.backgroundRepeat = `no-repeat`;
      this.logo_img_ref.style.backgroundPosition = `center`;
      this.logo_img_ref.innerHTML = "";

      // To convert local image into base64
      File.prototype.convertToBase64 = function (callback) {
        var reader = new FileReader();
        reader.onloadend = function (e) {
          callback(e.target.result, e.target.error);
        };
        reader.readAsDataURL(this);
      };
      var selectedFile = event.target.files[0];
      selectedFile.convertToBase64((base64) => {
        this.setState({ insuranceLogoImage: base64 });
      });
    }
  };

  deleteInsuranceClient = async (orderId) => {
    const { partnerId } = this.state;
    const url = configuration.deleteInsuranceClient;
    const payload = {
      id: orderId,
      partnerId: partnerId,
    };

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.value) {
      try {
        const response = await axios.post(url, payload);
        if (
          response.data &&
          response.data.code === 200 &&
          response.data.success
        ) {
          Toast.fire({
            type: "success",
            title: response.data.message,
          });
          this.getInsuranceDetails();
        } else {
          Toast.fire({
            type: "error",
            title: this.lang("Something went wrong"),
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  handleEditClick = (data) => {
    this.setState({
      updateInsuranceModal: !this.state.updateInsuranceModal,
      // updateInsuranceLogoImage: data.logo,
      updateInsuranceName: data.name,
      updateInsuranceEmail: data.email_id,
      updateInsuranceOrderBy: data.order_by,
      updateInsuranceWebsite: data.website,
      updateInsuranceRegNumber: data.register_no,
      updateInsuranceAddress: data.address,
      updateInsuranceNote: data.notes,
      updatePrimaryContact: data.primary_contact,
      updateSecondaryContact: data.secondary_contact,
      updateClientId: data.id,
      updateFooterTextColor:
        data.footer_text_color &&
        data.footer_text_color != "" &&
        data.footer_text_color.toUpperCase(),
      updateHeaderTextColor:
        data.header_text_color &&
        data.header_text_color != "" &&
        data.header_text_color.toUpperCase(),
      updatePrimaryColor:
        data.primary_color &&
        data.primary_color != "" &&
        data.primary_color.toUpperCase(),
      updateSecondaryColor:
        data.secondary_color &&
        data.secondary_color != "" &&
        data.secondary_color.toUpperCase(),
    });
    setTimeout(() => {
      if (
        this.update_logo_img_ref &&
        data.logo &&
        data.logo !== "" &&
        data.logo !== undefined &&
        data.logo !== null
      ) {
        this.update_logo_img_ref.style.backgroundImage = `url(${data.logo})`;
        this.update_logo_img_ref.style.backgroundSize = "contain";
        this.update_logo_img_ref.style.backgroundRepeat = "no-repeat";
        this.update_logo_img_ref.style.backgroundPosition = "center";
        this.update_logo_img_ref.innerHTML = "";
      }
    }, 500);
  };

  updateInsuranceClient = async (e) => {
    const {
      updateClientId,
      updateInsuranceName,
      updateInsuranceEmail,
      updateInsuranceWebsite,
      updateInsuranceRegNumber,
      updateInsuranceAddress,
      updateInsuranceNote,
      updatePrimaryContact,
      updateSecondaryContact,
      updatePrimaryColor,
      updateSecondaryColor,
      updateHeaderTextColor,
      updateFooterTextColor,
      updateInsuranceLogoImage,
      updateInsuranceOrderBy,
      partnerId,
    } = this.state;
    let errors = [];

    if (updateInsuranceName.trim() === "") {
      errors.push("Name is required.");
    }
    if (updateInsuranceEmail.trim() === "") {
      errors.push("Email is required.");
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        updateInsuranceEmail
      )
    ) {
      errors.push("Invalid email format");
    }

    if (errors.length > 0) {
      this.setState({ updateFieldError: errors });
    } else {
      this.setState({ updateFieldError: [], updateSubmitLoading: true });
      const url = configuration.updateInsuranceClient;
      const payload = {
        partnerId: partnerId,
        Logo: updateInsuranceLogoImage,
        Notes: updateInsuranceNote,
        Email: updateInsuranceEmail,
        Name: updateInsuranceName,
        PrimaryColor: updatePrimaryColor,
        SecondaryColor: updateSecondaryColor,
        HeaderTextColor: updateHeaderTextColor,
        FooterTextColor: updateFooterTextColor,
        PrimaryContact: updatePrimaryContact,
        SecondaryContact: updateSecondaryContact,
        Website: updateInsuranceWebsite,
        RegisterNo: updateInsuranceRegNumber,
        Address: updateInsuranceAddress,
        id: updateClientId,
        Order_by: updateInsuranceOrderBy,
      };

      try {
        const response = await axios.post(url, payload);
        if (
          response.data &&
          response.data.code === 200 &&
          response.data.success
        ) {
          this.setState(
            {
              updateSubmitLoading: false,
              updateInsuranceModal: false,
              updateFieldError: [],
            },
            () => {
              Toast.fire({
                type: "success",
                title: "Insurance has been updated successfully!",
              });
              this.getInsuranceDetails();
            }
          );
        } else {
          Toast.fire({
            type: "error",
            title: this.lang("Something went wrong"),
          });
          this.setState({ updateSubmitLoading: false });
        }
      } catch (error) {
        console.error(error);
        this.setState({ updateSubmitLoading: false });
      }
    }
  };

  onDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    const items = Array.from(this.state.allInsuranceClient);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);
    const updatedStateArray = items.map((item) => ({
      id: item.id,
    }));

    this.setState({ allInsuranceClient: items, dragOrder: updatedStateArray });
  };

  setDraggableOrder = async () => {
    const { dragOrder, partnerId } = this.state;
    if (!dragOrder.length > 0) {
      Toast.fire({
        type: "error",
        title: this.lang("You haven't change insurance order yet"),
      });
    } else {
      this.setState({ orderSubmitLoading: true });
      const url = configuration.setInsuranceClientOrder;
      const payload = {
        partnerId: partnerId,
        order_by: dragOrder,
      };
      try {
        const response = await axios.post(url, payload);
        if (response.data) {
          Toast.fire({
            type: "success",
            title: this.lang(response.data.message),
          });
          this.setState({ dragOrder: [], orderSubmitLoading: false }, () => {
            this.getInsuranceDetails();
          });
        } else {
          Toast.fire({
            type: "error",
            title: this.lang("Something went wrong"),
          });
          this.setState({ orderSubmitLoading: false });
        }
      } catch (error) {
        console.error(error);
        this.setState({ orderSubmitLoading: false });
      }
    }
  };

  render() {
    const {
      activeTab,
      insuranceName,
      insuranceEmail,
      insuranceWebsite,
      insuranceRegNumber,
      insuranceAddress,
      fieldRequireErrors,
      insuranceNote,
      primaryColor,
      secondaryColor,
      headerTextColor,
      footerTextColor,
      primaryContact,
      secondaryContact,
      allInsuranceClient,
      loading,
      updateInsuranceModal,
      updateFieldError,
      updateInsuranceName,
      updateInsuranceEmail,
      updateInsuranceWebsite,
      updateInsuranceRegNumber,
      updateInsuranceAddress,
      updateInsuranceNote,
      updatePrimaryContact,
      updateSecondaryContact,
      updatePrimaryColor,
      updateSecondaryColor,
      updateHeaderTextColor,
      updateFooterTextColor,
      createLoading,
      updateSubmitLoading,
      orderSubmitLoading,
    } = this.state;
    return (
      <>
        <div className="insurance_create_wrapper">
          <div className="main_insurance_profile">
            <div className="container-fluid">
              <div className="justify-content-center row">
                <div className="col-lg-11 col-md-12 col-sm-12">
                  <div>
                    <nav>
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className={`nav-link ${
                            activeTab === "nav-insurance-create" ? "active" : ""
                          }`}
                          id="nav-insurance-create-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-insurance-create"
                          type="button"
                          role="tab"
                          aria-controls="nav-insurance-create"
                          aria-selected={activeTab === "nav-insurance-create"}
                          onClick={() =>
                            this.handleTabClick("nav-insurance-create")
                          }
                        >
                          Insurance Creation
                        </button>
                        <button
                          className={`nav-link ${
                            activeTab === "nav-view-insurance" ? "active" : ""
                          }`}
                          id="nav-view-insurance-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-view-insurance"
                          type="button"
                          role="tab"
                          aria-controls="nav-view-insurance"
                          aria-selected={activeTab === "nav-view-insurance"}
                          onClick={() =>
                            this.handleTabClick("nav-view-insurance")
                          }
                        >
                          View Insurance
                        </button>
                      </div>
                    </nav>
                  </div>
                  <div className="tab-content">
                    <div
                      className={`tab-pane fade ${
                        activeTab === "nav-insurance-create"
                          ? "show active"
                          : ""
                      }`}
                      id="nav-insurance-create"
                      role="tabpanel"
                      aria-labelledby="nav-insurance-create-tab"
                    >
                      <div>
                        <form onSubmit={(e) => this.handleSubmit(e)}>
                          <div className="row p-0 align-items-center mb-3">
                            {/* insurance Name */}
                            <div className="col-lg-2 col-md-4 col-sm-12 text-center">
                              <div className={"company_logo"}>
                                <label htmlFor="getFile">
                                  <div
                                    ref={(comp) => {
                                      this.logo_img_ref = comp;
                                    }}
                                  >
                                    <p>{this.lang("Insurance Logo")}</p>
                                  </div>
                                </label>
                                <input
                                  id="getFile"
                                  style={{ display: "none" }}
                                  name="insuranceLogoImage"
                                  type="file"
                                  accept=".jpg,.jpeg,.png,.bmp"
                                  onChange={(e) => {
                                    this.onLogoImageSelect(e);
                                  }}
                                />
                                {fieldRequireErrors.includes(
                                  "Logo is required."
                                ) && (
                                  <p className="mt-2" style={{ color: "red" }}>
                                    {this.lang("Insurance Image is required.")}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-5 col-md-4 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Insurance Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="insuranceName"
                                  value={insuranceName}
                                  onChange={this.handleChange}
                                />
                                {fieldRequireErrors.includes(
                                  "Name is required."
                                ) && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Insurance name is required.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* insurance Email */}
                            <div className="col-lg-5 col-md-4 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Insurance Email
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="insuranceEmail"
                                  value={insuranceEmail}
                                  onChange={this.handleChange}
                                />
                                {fieldRequireErrors.includes(
                                  "Email is required."
                                ) ? (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Insurance Email is required.")}
                                  </span>
                                ) : fieldRequireErrors.includes(
                                    "Invalid email format"
                                  ) ? (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Please enter a valid email.")}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row p-0">
                            {/* insurance Website */}
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Insurance Website
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="insuranceWebsite"
                                  value={insuranceWebsite}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>

                            {/* insurance Registration Number */}
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Registration Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="insuranceRegNumber"
                                  value={insuranceRegNumber}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>

                            {/* insurance Address */}
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Address
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="insuranceAddress"
                                  value={insuranceAddress}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>

                            {/* insurance Note */}
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Notes
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="insuranceNote"
                                  value={insuranceNote}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>

                            {/* Primary contact number */}
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Primary Contact Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="primaryContact"
                                  value={primaryContact}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>

                            {/* Secondary contact number */}
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Secondary Contact Number
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="secondaryContact"
                                  value={secondaryContact}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>

                            {/* field for color pickers */}
                            {/* primary color picker */}
                            <div className="col-lg-6 col-md-12 col-sm-12">
                              <div className="color_main_wrapper">
                                <div className="mb-3 form-group">
                                  <label
                                    for="exampleInputEmail1"
                                    className="form-label"
                                  >
                                    {this.lang("Primary Color")}
                                  </label>
                                </div>
                                <div className="position-relative">
                                  <label
                                    htmlFor="getPrimaryColor"
                                    className="profile_input"
                                    style={{
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById("getPrimaryColor")
                                        .click()
                                    }
                                  >
                                    <div
                                      className="profile_input"
                                      style={{ border: "none" }}
                                    >
                                      <label className="placeholder placeholder-color-picker">
                                        {this.lang("Primary Color")} -{" "}
                                        {`${primaryColor}`.toUpperCase()}
                                      </label>
                                      <div
                                        className={"color_picker"}
                                        style={{
                                          backgroundColor: `${primaryColor}`,
                                        }}
                                      />
                                    </div>
                                  </label>
                                  <input
                                    value={primaryColor}
                                    style={{
                                      visibility: "hidden",
                                      height: 0,
                                      width: 0,
                                    }}
                                    type="color"
                                    id="getPrimaryColor"
                                    name="primaryColor"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* secondary color picker */}
                            <div className="col-lg-6 col-md-12 col-sm-12">
                              <div className="color_main_wrapper">
                                <div className="mb-3 form-group">
                                  <label
                                    for="exampleInputEmail1"
                                    className="form-label"
                                  >
                                    {this.lang("Secondary Color")}
                                  </label>
                                </div>
                                <div className="position-relative">
                                  <label
                                    htmlFor="getSecondaryColor"
                                    className="profile_input"
                                    style={{
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById("getSecondaryColor")
                                        .click()
                                    }
                                  >
                                    <div
                                      className="profile_input"
                                      style={{ border: "none" }}
                                    >
                                      <label className="placeholder placeholder-color-picker">
                                        {this.lang("Secondary Color")} -{" "}
                                        {`${secondaryColor}`.toUpperCase()}
                                      </label>
                                      <div
                                        className={"color_picker"}
                                        style={{
                                          backgroundColor: `${secondaryColor}`,
                                        }}
                                      />
                                    </div>
                                  </label>
                                  <input
                                    value={secondaryColor}
                                    style={{
                                      visibility: "hidden",
                                      height: 0,
                                      width: 0,
                                    }}
                                    type="color"
                                    id="getSecondaryColor"
                                    name="secondaryColor"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Header Text Color picker */}
                            <div className="col-lg-6 col-md-12 col-sm-12">
                              <div className="color_main_wrapper">
                                <div className="mb-3 form-group">
                                  <label
                                    for="exampleInputEmail1"
                                    className="form-label"
                                  >
                                    {this.lang("Header Text Color")}
                                  </label>
                                </div>
                                <div className="position-relative">
                                  <label
                                    htmlFor="getHeaderTextColor"
                                    className="profile_input"
                                    style={{
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById("getHeaderTextColor")
                                        .click()
                                    }
                                  >
                                    <div
                                      className="profile_input"
                                      style={{ border: "none" }}
                                    >
                                      <label className="placeholder placeholder-color-picker">
                                        {this.lang("Header Text Color")} -{" "}
                                        {`${headerTextColor}`.toUpperCase()}
                                      </label>
                                      <div
                                        className={"color_picker"}
                                        style={{
                                          backgroundColor: `${headerTextColor}`,
                                        }}
                                      />
                                    </div>
                                  </label>
                                  <input
                                    value={headerTextColor}
                                    style={{
                                      visibility: "hidden",
                                      height: 0,
                                      width: 0,
                                    }}
                                    type="color"
                                    id="getHeaderTextColor"
                                    name="headerTextColor"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Footer Text Color picker */}
                            <div className="col-lg-6 col-md-12 col-sm-12">
                              <div className="color_main_wrapper">
                                <div className="mb-3 form-group">
                                  <label
                                    for="exampleInputEmail1"
                                    className="form-label"
                                  >
                                    {this.lang("Footer Text Color")}
                                  </label>
                                </div>
                                <div className="position-relative">
                                  <label
                                    htmlFor="getFooterTextColor"
                                    className="profile_input"
                                    style={{
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById("getFooterTextColor")
                                        .click()
                                    }
                                  >
                                    <div
                                      className="profile_input"
                                      style={{ border: "none" }}
                                    >
                                      <label className="placeholder placeholder-color-picker">
                                        {this.lang("Footer Text Color")} -{" "}
                                        {`${footerTextColor}`.toUpperCase()}
                                      </label>
                                      <div
                                        className={"color_picker"}
                                        style={{
                                          backgroundColor: `${footerTextColor}`,
                                        }}
                                      />
                                    </div>
                                  </label>
                                  <input
                                    value={footerTextColor}
                                    style={{
                                      visibility: "hidden",
                                      height: 0,
                                      width: 0,
                                    }}
                                    type="color"
                                    id="getFooterTextColor"
                                    name="footerTextColor"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-12 col-md-12 col-sm-12 text-right">
                              <button
                                className="btn submit_button"
                                type="submit"
                              >
                                {createLoading ? (
                                  <Spinner />
                                ) : (
                                  this.lang("Submit")
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>

                    <div
                      className={`tab-pane fade ${
                        activeTab === "nav-view-insurance" ? "show active" : ""
                      }`}
                      id="nav-view-insurance"
                      role="tabpanel"
                      aria-labelledby="nav-view-insurance-tab"
                    >
                      <div className="row insurance_search_main_wrapper p-0 mb-3 justify-content-between">
                        {activeTab === "nav-view-insurance" && (
                          <>
                            <div className="col-lg-3 col-md-6 col-sm-12 p-0 pr-1"></div>
                          </>
                        )}
                      </div>
                      <div>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className="text-center">Sr. No</th>
                                  <th>Insurance Name</th>
                                  <th>Insurance Logo</th>
                                  <th>Email Address</th>
                                  <th>Website</th>
                                  {/* <th>Reg. No</th> */}
                                  <th>Mobile No</th>
                                  <th>Address</th>
                                  <th className="text-center">Colors</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              {loading && (
                                <tr>
                                  <td colSpan={"9"}>
                                    <Spinner />
                                  </td>
                                </tr>
                              )}

                              <Droppable droppableId="table-body">
                                {(provided) => (
                                  <tbody
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                  >
                                    {!loading &&
                                    allInsuranceClient &&
                                    Array.isArray(allInsuranceClient) &&
                                    allInsuranceClient.length > 0
                                      ? allInsuranceClient.map(
                                          (data, index) => (
                                            <Draggable
                                              key={`${data.order_by}-${index}`}
                                              draggableId={`${data.order_by}-${index}`}
                                              index={index}
                                            >
                                              {(provided) => (
                                                <tr
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps} // Keep only draggableProps here for the entire row
                                                >
                                                  <td className="text-center">
                                                    {data.order_by}
                                                  </td>
                                                  <td>{data.name || "-"}</td>
                                                  <td className="insurance_logo_row text-center">
                                                    <div className="insurance_logo_img">
                                                      <img
                                                        src={data.logo}
                                                        alt={data.name}
                                                        title={data.name}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td>
                                                    {data.email_id || "-"}
                                                  </td>
                                                  <td>{data.website || "-"}</td>
                                                  
                                                  {/* <td>
                                                    {data.register_no || "-"}
                                                  </td> */}
                                                  <td>
                                                    <div>
                                                      <span style={{whiteSpace:"nowrap"}}>
                                                        {data.primary_contact &&
                                                          data.primary_contact !==
                                                            "" ?
                                                          data.primary_contact.toUpperCase() : "-"}
                                                      </span>
                                                    </div>
                                                    <div>
                                                      <span style={{whiteSpace:"nowrap"}}>
                                                        {data.secondary_contact &&
                                                          data.secondary_contact !==
                                                            "" ?
                                                          data.secondary_contact.toUpperCase() : "-"}
                                                      </span>
                                                    </div>
                                                  </td>
                                                  <td>{data.address || "-"}</td>
                                                  <td className="color_row">
                                                    <div className="color_grid">
                                                      <span className="color_text">
                                                        <span
                                                          className="color_box"
                                                          style={{
                                                            backgroundColor:
                                                              data.primary_color,
                                                          }}
                                                        ></span>
                                                        {data.primary_color &&
                                                          data.primary_color !==
                                                            "-" &&
                                                          data.primary_color.toUpperCase()}
                                                      </span>
                                                      <span className="color_text">
                                                        <span
                                                          className="color_box"
                                                          style={{
                                                            backgroundColor:
                                                              data.secondary_color,
                                                          }}
                                                        ></span>
                                                        {data.secondary_color &&
                                                          data.secondary_color !==
                                                            "-" &&
                                                          data.secondary_color.toUpperCase()}
                                                      </span>
                                                      <span className="color_text">
                                                        <span
                                                          className="color_box"
                                                          style={{
                                                            backgroundColor:
                                                              data.header_text_color,
                                                          }}
                                                        ></span>
                                                        {data.header_text_color &&
                                                          data.header_text_color !==
                                                            "-" &&
                                                          data.header_text_color.toUpperCase()}
                                                      </span>
                                                      <span className="color_text">
                                                        <span
                                                          className="color_box"
                                                          style={{
                                                            backgroundColor:
                                                              data.footer_text_color,
                                                          }}
                                                        ></span>
                                                        {data.footer_text_color &&
                                                          data.footer_text_color !==
                                                            "-" &&
                                                          data.footer_text_color.toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div className="text-center d-flex align-item-center">
                                                      <button
                                                        className="edit_btn"
                                                        onClick={() =>
                                                          this.handleEditClick(
                                                            data
                                                          )
                                                        }
                                                      >
                                                        <i className="fa fa-pencil"></i>
                                                      </button>
                                                      <button
                                                        className="edit_btn"
                                                        onClick={() =>
                                                          this.deleteInsuranceClient(
                                                            data.id
                                                          )
                                                        }
                                                      >
                                                        <i className="fa fa-trash"></i>
                                                      </button>

                                                      <div
                                                        className="moveable_btn"
                                                        {...provided.dragHandleProps}
                                                      >
                                                        <i className="fa fa-arrow-up"></i>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                            </Draggable>
                                          )
                                        )
                                      : !loading && (
                                          <tr>
                                            <td
                                              colSpan="9"
                                              className="text-center"
                                            >
                                              No record Found
                                            </td>
                                          </tr>
                                        )}
                                    {provided.placeholder}
                                  </tbody>
                                )}
                              </Droppable>
                            </table>
                            {/* Footer */}
                          </div>
                        </DragDropContext>
                        <div className="col-lg-12 col-md-12 col-sm-12 text-right p-0 mt-3">
                          <button
                            className="btn submit_button"
                            type="button"
                            // disabled={!dragOrder.length > 0}
                            onClick={() => {
                              this.setDraggableOrder();
                            }}
                          >
                            {orderSubmitLoading ? (
                              <Spinner />
                            ) : (
                              this.lang("Submit")
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          centered={true}
          size="xl"
          scrollable="true"
          isOpen={updateInsuranceModal}
          className="theme_modal_user theme_modal_insurance_management"
          backdrop="static"
          toggle={() => this.setState({ updateInsuranceModal: false })}
        >
          <ModalHeader className="p-3">Update Insurance Client</ModalHeader>

          <ModalBody>
            <form
            // onSubmit={(e) => {
            //   this.updateInsuranceClient(e);
            // }}
            >
              <div>
                <div className="row p-0">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div
                      style={{
                        width: "100%",
                        display: "grid",
                        placeItems: "center",
                        marginTop: 10,
                      }}
                      className={"company_logo"}
                    >
                      <label htmlFor="getUpdateFile">
                        <div
                          ref={(comp) => {
                            this.update_logo_img_ref = comp;
                          }}
                        >
                          <p
                            style={{
                              fontSize: 16,
                              color: "#454545",
                              fontWeight: "bold",
                              margin: 0,
                              padding: "0 10px",
                            }}
                          >
                            {this.lang("Insurance Logo")}
                          </p>
                        </div>
                      </label>
                      <input
                        id="getUpdateFile"
                        style={{ display: "none" }}
                        name="updateInsuranceLogoImage"
                        type="file"
                        accept=".jpg,.jpeg,.png,.bmp"
                        onChange={(e) => {
                          this.onUpdateLogoImageSelect(e);
                        }}
                      />
                      {updateFieldError.includes("Logo is required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Insurance Image is required.")}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row p-0">
                  {/* insurance Name */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Insurance Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateInsuranceName"
                        value={updateInsuranceName}
                        onChange={this.handleChange}
                      />
                      {updateFieldError.includes("Name is required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Insurance name is required.")}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* insurance Email */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Insurance Email
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateInsuranceEmail"
                        value={updateInsuranceEmail}
                        onChange={this.handleChange}
                      />
                      {updateFieldError.includes("Email is required.") ? (
                        <span style={{ color: "red" }}>
                          {this.lang("Insurance Email is required.")}
                        </span>
                      ) : fieldRequireErrors.includes(
                          "Invalid email format"
                        ) ? (
                        <span style={{ color: "red" }}>
                          {this.lang("Please enter a valid email.")}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {/* insurance Website */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Insurance Website
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateInsuranceWebsite"
                        value={updateInsuranceWebsite}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  {/* insurance Registration Number */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Registration Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateInsuranceRegNumber"
                        value={updateInsuranceRegNumber}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  {/* insurance Address */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateInsuranceAddress"
                        value={updateInsuranceAddress}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  {/* insurance Note */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Notes
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateInsuranceNote"
                        value={updateInsuranceNote}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  {/* Primary contact number */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Primary Contact Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updatePrimaryContact"
                        value={updatePrimaryContact}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  {/* Secondary contact number */}
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Secondary Contact Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="updateSecondaryContact"
                        value={updateSecondaryContact}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  {/* field for color pickers */}
                  {/* primary color picker */}
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="color_main_wrapper">
                      <div className="mb-0 form-group">
                        <label for="exampleInputEmail1" className="form-label">
                          {this.lang("Primary Color")}
                        </label>
                      </div>
                      <div className="position-relative">
                        <label
                          htmlFor="getUpdatePrimaryColor"
                          className="profile_input"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document
                              .getElementById("getUpdatePrimaryColor")
                              .click()
                          }
                        >
                          <div
                            className="profile_input"
                            style={{ border: "none" }}
                          >
                            <label className="placeholder placeholder-color-picker">
                              {this.lang("Primary Color")} -{" "}
                              {`${updatePrimaryColor}`.toUpperCase()}
                            </label>
                            <div
                              className={"color_picker"}
                              style={{
                                backgroundColor: `${updatePrimaryColor}`,
                              }}
                            />
                          </div>
                        </label>
                        <input
                          value={updatePrimaryColor}
                          style={{
                            visibility: "hidden",
                            height: 0,
                            width: 0,
                          }}
                          type="color"
                          id="getUpdatePrimaryColor"
                          name="updatePrimaryColor"
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* secondary color picker */}
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="color_main_wrapper">
                      <div className="mb-0 form-group">
                        <label for="exampleInputEmail1" className="form-label">
                          {this.lang("Secondary Color")}
                        </label>
                      </div>
                      <div className="position-relative">
                        <label
                          htmlFor="getUpdateSecondaryColor"
                          className="profile_input"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document
                              .getElementById("getUpdateSecondaryColor")
                              .click()
                          }
                        >
                          <div
                            className="profile_input"
                            style={{ border: "none" }}
                          >
                            <label className="placeholder placeholder-color-picker">
                              {this.lang("Secondary Color")} -{" "}
                              {`${updateSecondaryColor}`.toUpperCase()}
                            </label>
                            <div
                              className={"color_picker"}
                              style={{
                                backgroundColor: `${updateSecondaryColor}`,
                              }}
                            />
                          </div>
                        </label>
                        <input
                          value={updateSecondaryColor}
                          style={{
                            visibility: "hidden",
                            height: 0,
                            width: 0,
                          }}
                          type="color"
                          id="getUpdateSecondaryColor"
                          name="updateSecondaryColor"
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Header Text Color picker */}
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="color_main_wrapper">
                      <div className="mb-0 form-group">
                        <label for="exampleInputEmail1" className="form-label">
                          {this.lang("Header Text Color")}
                        </label>
                      </div>
                      <div className="position-relative">
                        <label
                          htmlFor="getUpdateHeaderTextColor"
                          className="profile_input"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document
                              .getElementById("getUpdateHeaderTextColor")
                              .click()
                          }
                        >
                          <div
                            className="profile_input"
                            style={{ border: "none" }}
                          >
                            <label className="placeholder placeholder-color-picker">
                              {this.lang("Header Text Color")} -{" "}
                              {`${updateHeaderTextColor}`.toUpperCase()}
                            </label>
                            <div
                              className={"color_picker"}
                              style={{
                                backgroundColor: `${updateHeaderTextColor}`,
                              }}
                            />
                          </div>
                        </label>
                        <input
                          value={updateHeaderTextColor}
                          style={{
                            visibility: "hidden",
                            height: 0,
                            width: 0,
                          }}
                          type="color"
                          id="getUpdateHeaderTextColor"
                          name="updateHeaderTextColor"
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Footer Text Color picker */}
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="color_main_wrapper">
                      <div className="mb-0 form-group">
                        <label for="exampleInputEmail1" className="form-label">
                          {this.lang("Footer Text Color")}
                        </label>
                      </div>
                      <div className="position-relative">
                        <label
                          htmlFor="getUpdateFooterTextColor"
                          className="profile_input"
                          style={{
                            position: "relative",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document
                              .getElementById("getUpdateFooterTextColor")
                              .click()
                          }
                        >
                          <div
                            className="profile_input"
                            style={{ border: "none" }}
                          >
                            <label className="placeholder placeholder-color-picker">
                              {this.lang("Footer Text Color")} -{" "}
                              {`${updateFooterTextColor}`.toUpperCase()}
                            </label>
                            <div
                              className={"color_picker"}
                              style={{
                                backgroundColor: `${updateFooterTextColor}`,
                              }}
                            />
                          </div>
                        </label>
                        <input
                          value={updateFooterTextColor}
                          style={{
                            visibility: "hidden",
                            height: 0,
                            width: 0,
                          }}
                          type="color"
                          id="getUpdateFooterTextColor"
                          name="updateFooterTextColor"
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div>
              <button
                className="btn btn-md p-2 mr-2 cancel_btn"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    updateInsuranceModal: false,
                    updateFieldError: [],
                  });
                }}
              >
                {this.lang("Cancel")}
              </button>
              <button
                onClick={(e) => {
                  this.updateInsuranceClient(e);
                }}
                className="btn btn-md p-2 submit_button"
                type="button"
              >
                {updateSubmitLoading ? <Spinner /> : this.lang("Submit")}
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
